import { Navigate } from "react-router-dom";
import { useSelector } from "react-redux";
import CandidateSearchPage from "layouts/job/components/CandidateSearchPage";

function UsersAdvancedCandidateSearch() {
  const { adminData, isSuperAdmin } = useSelector((state) => ({
    adminData: state?.auth?.adminData,
    isSuperAdmin: state?.auth?.adminData?.isSuperAdmin || false,
  }));

  const hasViewAccess =
    isSuperAdmin ||
    adminData?.permissions?.some(
      (perm) => perm.module === "user" && perm.actions?.includes("view"),
    );

  if (!hasViewAccess) {
    return <Navigate to="/home" replace />;
  }

  return <CandidateSearchPage mode="users" />;
}

export default UsersAdvancedCandidateSearch;
